import React from 'react';
import './loader-component.scss';

export default function LoaderComponent() {
  return (
    <div className="loader-component">
      <img src="/assets/loader/loader.gif" alt="loader" height="90px" />
    </div>
  );
}
